const gameType = [
  'pg',
  'pp'
]
export default gameType;



// WEBPACK FOOTER //
// ./src/utils/platType/game.js